import React from "react";
import { Link } from "@wrstudios/components";
import IconComputer from "../../icons/IconComputer";
import { Container, Title, Text } from "./styled/error";

function Error() {
  return (
    <Container>
      <Title>Page Not Found</Title>
      <Text>
        Awkward... wanna <Link to="/">go home</Link>?
      </Text>
      <IconComputer />
    </Container>
  );
}

export default Error;
